/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ArtifactListResponse {
    getFixupPrototypeFunction() { return ArtifactListResponse.fixupPrototype; }

    static newInstance(model: Partial<ArtifactListResponse>): ArtifactListResponse {
        let obj = Object.assign(new ArtifactListResponse(), model);
        ArtifactListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ArtifactListResponse>): ArtifactListResponse {
        if (!model) return null;
        return ArtifactListResponse.newInstance(<ArtifactListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ArtifactListResponse) {
        if (!obj) return;

        models.ArtifactListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ArtifactListResponse): boolean {
        Object.setPrototypeOf(obj, ArtifactListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
